export enum Platform {
  /**
   * 网站端
   */
  Website = '101',
  /**
   * 微信端
   */
  Wechat = '102',
  /**
   * app端
   */
  App = '103'
}

export enum MsgType {
  /**
   * 文本消息
   */
  Text = '2000',
  /**
   * 系统消息
   */
  System = '2001',
  /**
   * 排队消息
   */
  Queue = '2002',
  /**
   * 消息超时
   */
  Timeout = '2003',
  /**
   * 初始化
   */
  Init = '2004',
  /**
   * 图片消息
   */
  Image = '2005',
  /**
   * 满意度评价
   */
  Satisfy = '4002'
}

export enum Response {
  /**
   * 成功
   */
  Success = '0000',
  /**
   * 用户名不存在
   */
  UserNotFound = '1001',
  /**
   * 密码错误
   */
  PasswordError = '1002',
  /**
   * 系统异常
   */
  SystemError = '1003',
}

export enum ErrorType {
  /**
   * 坐席正忙（在工作时间无坐席登陆）
   */
  NoAgent = '3000',
  /**
   * 排队继续等待询问（询问是否继续等待，继续等待将接受配对消息，如不等待关闭连接）
   */
  Queue = '3001',
  /**
   * 坐席退出关闭连接
   */
  AgentEnd = '3002',
  /**
   * 排队人数在10人以上（不包含10人）
   */
  LimitExceeded = '3003'
}

export enum Type {
  /**
   * 市民（即用户）
   */
  User = '1',
  /**
   * 坐席
   */
  Agent = '2'
}

export enum UserType {
  /**
   * 单位
   */
  Enterprise = '1',
   /**
    * 个人
    */
  Person = '2'
}

export enum CustomerType {
  /**
   * 匿名
   */
  Anonymous = '1',
  /**
   * 用户
   */
  User = '2'
}